"use client"

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ThemeToggle from "../components/auth/ThemeToggle";
import { AuthStatus, type ForgotPasswordFormData } from "../types/auth";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { forgotPasswordUser } from "../redux/slices/authSlice";
import { toast } from "react-toastify";
import Loading from "../components/auth/Loading";

const ForgotPassword: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { status, error } = useAppSelector((state) => state.auth);
  const [formData, setFormData] = useState<ForgotPasswordFormData>({ email: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(()=>{
    if(error){
      if(typeof error === 'string'){
        toast.error(error)
      }
    }
  },[error])
  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    setSubmitted(true);
    dispatch(forgotPasswordUser(formData.email));
  };

  useEffect(() => {
    
    if (submitted && status === "succeeded") {
      toast.success("OTP sent please your check your email")
      navigate("/reset", { state: { email: formData.email } });
    }
  }, [submitted, status, formData.email, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#261d57] text-gray-900 dark:text-white transition-all">
      <ThemeToggle />
      <div className="max-w-6xl w-full h-auto sm:h-[600px] rounded-2xl overflow-hidden flex flex-col sm:flex-row">
        <div className="hidden min-h-screen sm:flex sm:w-1/2 flex-col justify-between">
          <img src="/landing/login.png" className="w-full min-h-screen" alt="Background" />
        </div>
        <div className="w-full sm:w-1/2 p-6 rounded-2xl bg-gray-100 dark:bg-gray-800">
          <div className="w-full p-6 rounded-2xl">
            <div className="flex flex-col items-center mb-6">
              <img src="./logo/green-logo.png" className="w-12 h-12 object-cover" alt="Logo" />
              <h1 className="text-xl font-bold mt-2 text-gray-900 dark:text-white">Forgot Password</h1>
              <p className="text-gray-400 dark:text-muted font-normal text-sm text-center">
                Enter your email and we'll send you a code to reset your password
              </p>
            </div>


            <form onSubmit={handleSubmit} className="space-y-2 sm:space-y-4 w-full">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-2.5 dark:text-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md text-gray-900 dark:text-muted text-sm focus:ring-[#3FBBA3] focus:border-[#3FBBA3] dark:focus:ring-[#3FBBA3] dark:focus:border-[#3FBBA3]"
                placeholder="Enter Email ID"
                required
              />
              <button
                type="submit"
                className="w-full bg-[#3FBBA3] hover:bg-[#3FBBA3] text-white font-medium py-2.5 px-4 rounded-md transition duration-150 ease-in-out mt-6 disabled:opacity-90 disabled:cursor-not-allowed "
                disabled={status === "loading"}
              >
               {status === AuthStatus.LOADING ? (
                <Loading text="Sending reset code, please wait..." />
               ) : (
                "Send Reset Code"
               )}
              
                
              </button>
            </form>

            <p className="mt-1 text-center text-xs text-gray-400">
              Remember your password?{" "}
              <Link to="/login" className="text-[#3FBBA3] hover:text-[#3FBBA3]">
                Back to Login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
